var numberToCurrency = num => !num || Number.isNaN(num) || num === 0 ? null : num.toLocaleString('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 0
});
export default numberToCurrency;